module.exports = "fragment Error on Error {\n  code\n  message\n}\n"